// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__F6iPW","open":"styles_open__9K25O","faq__question":"styles_faq__question__UM37c","faq__answer":"styles_faq__answer__2LlWp"};